import { Injectable } from '@angular/core';
import { Buffer } from 'buffer';
import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import {
    map,
    catchError,
    retry,
    retryWhen,
    scan,
    delay,
    timeout,
} from 'rxjs/operators';
import { LoginService } from '../home/login.service';
import { IAccount } from './account';
import { ICustomer } from '../home/customer';
import { IZip } from './zipinfo';
import { IAddress } from './address';
import { IReferralMarketTypes } from './referralMarketTypes';
import { ICustomerInfoResponse } from './customerinforesponse';
import { ApiCacheService } from '../core/api-cache.service';

@Injectable()
export class CreateAccountService {
    //private _accountCreateUrl = 'http://localhost/webapitest/api/CreateCustomer/';

    private _accountCreateUrl =
        'https://samplecart.lbri.net/api/api/CreateCustomer/';
    private _accountCreateUrl2 =
        'https://webapi.bydesign.com/Lbri/api/users/customer';
    private _accountAddressUrl =
        'https://webapi.securefreedom.com/Lbri/api/order/Address?customerDID=';
    private createNoteUrl =
        'https://samplecart.lbri.net/api/api/CreateProfileNote/';
    private createNoteUrl2 = 'https://webapi.bydesign.com/api/Customer/';

    private checkEmailUrl = 'https://samplecart.lbri.net/api/api/CheckEmail/';
    private checkDuplicateEmailUrl =
        'https://samplecart.lbri.net/api/api/CheckDuplicateEmail/';
    private zipLookupUrl = 'https://samplecart.lbri.net/api/api/ZipLookup/';
    private validateAddressUrl =
        'https://samplecart.lbri.net/api/api/ValidateAddress/';
    private _body: any;
    public addresses!: IAddress;
    private theCustId: any;
    public myCustID!: string;
    public response_number: any;
    private _marketTypesUrl!: string;
    public langKey: number;
    constructor(private _http: HttpClient, private login: LoginService, private cache: ApiCacheService) { }
    getLocale(): any {
        var currentLocale = localStorage.getItem('locale');
        return currentLocale;
    }
    getLangKey(): any {
        let lc = this.getLocale();

        if (lc === 'en') this.langKey = 1;
        else this.langKey = 134;
    }
    public lbriAPI: any;
    // createAddress(custId: string, street: string, city: string, state: string, zip: string, phone: string) : Observable<ICustomer>{
    //     var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
    //     this.login.token = currentUser && currentUser.access_token;
    //     this.headers =  new Headers({
    //             'scope': 'write',
    //             // 'content-type': 'application/x-www-form-urlencoded'
    //             'Authorization': "Bearer " + this.login.token
    //         });

    //     this.options = new RequestOptions({
    //     headers: this.headers
    //     });
    //     this. _body = {
    //                     "Street1" : street,
    //                     "City" : city,
    //                     "State": state,
    //                     "PostalCode" : zip,
    //                     "Phone": phone
    //             };
    //     return this._http.post(this._accountAddressUrl + custId, this._body, this.options)
    //     .map((response: Response) =>  <ICustomer> response.json())
    //     .do(data => console.log('All: ' + JSON.stringify(data)))
    //     .catch(this.handleError);
    // }

    validateAddress(
        f: string | null,
        l: string | null,
        billst1: string | null,
        billcity: string | null,
        billstate: string | null,
        billzip: string | null,
        billcounty: string | null,
        billst2?: string
    ): Observable<IAddress> {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
        
        var lbriToken = JSON.parse(localStorage.getItem('lbriToken') || '{}');

        let headers = new HttpHeaders({
            'content-type': 'application/json',
            //'Authorization': "Bearer " + lbriToken.token
        });

        let options = {
            headers: headers,
        };

        this._body = {
            FirstName: f,
            LastName: l,
            Street1: billst1,
            Street2: billst2,
            City: billcity,
            State: billstate,
            PostalCode: billzip,
            County: billcounty,
            Country: 'USA',
        };
        return this._http
            .post<IAddress>(this.validateAddressUrl, this._body, options)
            .pipe(
                retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),
            );
    }

    // this gets all of the customers information to be used with the payment client.

    getCustomerInfo(custId: string) {
        //var lbriToken = JSON.parse(localStorage.getItem('lbriToken'));

        //console.log("LBRI TOKEN FROM GET SESSION TOKEN: " + lbriToken.access_token);
        let myHeaders = new HttpHeaders({
            scope: 'write',
            'content-type': 'application/json',
            // 'Authorization': "Bearer " + this.currentUser.access_token
            Authorization:
                'Basic ' +
                Buffer.from('postcardapi:6TfC5RdX$$', 'utf8').toString('base64'),
        });

        let httpOptionsNew = {
            headers: myHeaders,
        };

        let url =
            'https://webapi.securefreedom.com/Lbri/api/user/customer/' +
            custId.replace('-->c_', '') +
            '/info';
        const key = `customerInfo:${custId.replace('-->c_', '')}`;
        return this.cache.get<ICustomerInfoResponse>(
            key,
            () => this._http.get<ICustomerInfoResponse>(url, httpOptionsNew),
            5 * 60_000
        );
    }

    createAccount(
        rDID: string,
        f: string,
        l: string,
        billst1: string,
        billcity: string,
        billstate: string,
        billzip: string,
        phone: string,
        p: string,
        e: string,
        billcounty: string,
        referaltypeid: number,
        referraltext: string
    ) {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...


        // var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
        // this.login.token = currentUser && currentUser.access_token;
        //this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken'));
        let headers = new HttpHeaders({
            'content-type': 'application/json',
        });

        let options = {
            headers: headers,
        };

        this._body = {
            FirstName: f.trim(),
            LastName: l,
            BillStreet1: billst1,
            BillCity: billcity,
            BillState: billstate,
            BillPostalCode: billzip,
            Phone1: phone,
            Password: p.trim(),
            Email: e.trim(),
            BillCounty: billcounty,
            ReferralMarketTypeId: referaltypeid,
            ReferralMarketTypeInput: referraltext,
        };
        return this._http
            .post<string>(this._accountCreateUrl + rDID, this._body, options)

            .pipe(
                retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),

                //.do(data => console.log('All: ' + JSON.stringify(data) ))
                catchError(this.handleError)
            );
    }

    createAccount2(
        rDID: string,
        f: string,
        l: string,
        billst1: string,
        billcity: string,
        billstate: string,
        billzip: string,
        phone: string,
        p: string,
        e: string,
        billcounty: string,
        referaltypeid: number,
        referraltext: string
    ) {
        // var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
        // this.login.token = currentUser && currentUser.access_token;
        //this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken'));
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...


        var creds1 = Buffer.from('postcardapi:6TfC5RdX$$', 'utf8').toString(
            'base64'
        );
        let custLangKey = localStorage.getItem('newLocaleId');
        let headers = new HttpHeaders({
            'content-type': 'application/json',
            Authorization: 'Basic ' + creds1,
        });
        const langKeyID = parseInt(custLangKey);
        let options = {
            headers: headers,
        };

        this._body = {
            FirstName: f.trim(),
            LastName: l,
            Email: e.trim(),
            Password: p.trim(),
            RepDID: rDID,
            Company: '',
            BillingStreet1: billst1,
            BillingCity: billcity,
            BillingState: billstate,
            BillingPostalCode: billzip,
            BillingCounty: billcounty,
            BillingCountry: 'USA',
            ShippingStreet1: billst1,
            ShippingCity: billcity,
            ShippingState: billstate,
            ShippingPostalCode: billzip,
            ShippingCounty: billcounty,
            ShippingCountry: 'USA',
            Phone1: phone,
            ReferralMarketType: referaltypeid,
            ReferralMarketTypeInput: referraltext,
            CustomerType: 3,
            SendAutoResponders: true,
            PreferredCulture: langKeyID,
        };
        return this._http
            .post<string>(this._accountCreateUrl2, this._body, options)

            .pipe(
                retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),

                //.do(data => console.log('All: ' + JSON.stringify(data) ))
                catchError(this.handleError)
            );
    }
    checkEmail(email: string) {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        // var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
        // this.login.token = currentUser && currentUser.access_token;
        let headers = new HttpHeaders({
            'content-type': 'application/json',
        });

        let options = {
            headers: headers,
        };

        this._body = {
            Email: email,
        };

        // return this._http.post(this.checkEmailUrl, this._body, options)
        return this._http
            .post<boolean>(this.checkEmailUrl, this._body, options)
            .pipe(
                retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
                catchError(this.handleError)
            );
    }

    checkDuplicateEmail(email: string) {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        // var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
        // this.login.token = currentUser && currentUser.access_token;
        let headers = new HttpHeaders({
            'content-type': 'application/json',
        });

        let options = {
            headers: headers,
        };

        this._body = {
            Email: email,
        };

        return this._http
            .post<boolean>(this.checkDuplicateEmailUrl, this._body, options)
            .pipe(
                retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
                catchError(this.handleError)
            );

        //.do(data => console.log('All: ' + JSON.stringify(data) ))
    }
    getMarketTypes() {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        //credentails for API call - using basic auth
        var creds1 = Buffer.from('postcardapi:6TfC5RdX$$', 'utf8').toString(
            'base64'
        );

        let headers = new HttpHeaders({
            scope: 'write',
            // 'content-type': 'application/x-www-form-urlencoded'
            Authorization: 'Basic ' + creds1,
            // btoa("postcardapi:6TfC5RdX$$")
        });
        let options1 = {
            headers: headers,
        };
        let _body = {};

        this._marketTypesUrl =
            'https://webapi.securefreedom.com/Lbri/API/Admin/ReferralMarketType?localeID=-1';
        return this._http
            .get<IReferralMarketTypes[]>(this._marketTypesUrl, options1)
            .pipe(retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),catchError(this.handleError));
    }
    zipLookup(zipcode: string | null) {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        var lbriToken = JSON.parse(localStorage.getItem('lbriToken') || '{}');

        let headers = new HttpHeaders({
            'content-type': 'application/json',
            Authorization: 'Bearer ' + lbriToken.token,
        });

        let options = {
            headers: headers,
        };

        this._body = {
            zipcode: zipcode,
        };

        return this._http
            .post<IZip[]>(this.zipLookupUrl + zipcode, this._body, options)
            .pipe(
               retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
            );
    }

    createNote2(custId: string | null, message: string | null) {
        // var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
        // this.login.token = currentUser && currentUser.access_token;
        //this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken'));
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        let headers = new HttpHeaders({
            'content-type': 'application/json',
        });

        let options = {
            headers: headers,
        };

        this._body = {
            ID: '',
            CustomerNoteCategoryID: 41,
            CorrespondenceTypeID: 1,
            CustomerDID: custId,
            Message: message,
            Subject: "How did you hear about L'BRI?",
            Unresolved: false,
            IsCritical: false,
        };
        return this._http
            .post(this.createNoteUrl2 + custId + '/Note', this._body, options)
            .pipe(
               retry({
                count: MAX_RETRIES,
                delay: (error: HttpErrorResponse, retryCount: number) => {
                    // Retry only on transient failures
                    const status = error.status;

                    const isTransient =
                        status === 0 ||                 // network / CORS / DNS / offline
                        status === 429 ||               // rate limit
                        (status >= 500 && status < 600); // server errors

                    if (!isTransient) {
                        return throwError(() => error);
                    }

                    // exponential backoff with cap
                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                    return timer(backoff);
                }
            }),
            );
    }

    // createNote(custId: string | null, message: string| null) {
    //     // var currentUser = JSON.parse(localStorage.getItem('authorizationData'));
    //     // this.login.token = currentUser && currentUser.access_token;
    //     //this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken'));
    //     let headers = new HttpHeaders({
    //         'content-type': 'application/json'

    //     });

    //     let options = {
    //         headers: headers
    //     };

    //     this._body = {
    //         "CustomerDID": custId,
    //         "Message": message

    //     };
    //     return this._http.post(this.createNoteUrl, this._body, options)
    //         .pipe(
    //             retryWhen(e => e.pipe(scan((errorCount, error) => {
    //                 if (errorCount >= 3) {
    //                     throw error;
    //                 }
    //                 return errorCount + 1;
    //             }, 0),
    //                 delay(1000)
    //             )),
    //         );
    // }

    handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side errors
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        //window.alert(errorMessage);
        return throwError(() => new Error(errorMessage));
    }
}
